import { render, staticRenderFns } from "./PopoverPessoa.vue?vue&type=template&id=135590e0&"
import script from "./PopoverPessoa.vue?vue&type=script&lang=js&"
export * from "./PopoverPessoa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports